import { useStaticQuery, graphql } from "gatsby";

const useStaticData = () => {
    const cmsData = useStaticQuery(
        graphql`{
          contentfulJobFilter {
            filterData {
              selectFields {
                jobFamily {
                  options {
                    label
                    value
                  }
                }
              }
            }
            countriesList {
              countryName
              countryCode
              locations {
                label
                value
              }
              stateWithLocations {
                locations {
                  label
                  value
                }
                stateCode
                stateName
              }
            }
          }
        }`
      )

    return cmsData
}

export default useStaticData
